export default __webpack_public_path__ + "static/media/losant.1cf566a3.svg";